var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBi = function SvgBi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff8c4b95-5d4c-4762-8cfc-6dc1eb56e9eca)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "decbc8af-cc79-4ec5-8de0-17e7b22a266fb",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#decbc8af-cc79-4ec5-8de0-17e7b22a266fb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0091E",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#08B731",
    fillRule: "evenodd",
    d: "m0 0 10 8-10 7zm21 0L11 8l10 7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.158 6.456 0 1.5V0h1.5l6.847 4.74A3.48 3.48 0 0 1 10.5 4c.812 0 1.56.276 2.153.74L19.5 0H21v1.5l-7.158 4.956q.156.497.158 1.044-.002.547-.158 1.044L21 13.5V15h-1.5l-6.847-4.74c-.594.464-1.34.74-2.153.74s-1.56-.276-2.153-.74L1.5 15H0v-1.5l7.158-4.956A3.5 3.5 0 0 1 7 7.5q.002-.548.158-1.044",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0091E",
    fillRule: "evenodd",
    d: "M10 6h1v1h-1zm1 2h1v1h-1zM9 8h1v1H9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ff8c4b95-5d4c-4762-8cfc-6dc1eb56e9eca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgBi;